module.exports = __webpack_public_path__ + "media/newstyle/images/logo-submarino-color-0d91fc5d0d78ff0971f2dee9c016faea.png";